// /admin: the panel for commercial operators; a finance-only operator lands on credit and consumption.
import { Navigate } from "@tanstack/react-router";
import { AdminDashboard } from "./admin-dashboard";
import { useOperatorRoles } from "./admin-layout";

export function AdminHome() {
  const roles = useOperatorRoles();
  if (roles.length > 0 && !roles.includes("SUPER_ADMIN") && !roles.includes("COMMERCIAL_ADMIN"))
    return <Navigate to="/admin/finance" />;
  return <AdminDashboard />;
}
